import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Grid } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { ClinicianSelector } from "../../components/ClinicianSelector";
import { ClinicDetails } from "../models";
import { ApplicationState } from "../../models";
import { loadCustomers } from "../../../crud/customer";
import { getCustomerNamesForBillableCustomerIds, getCustomerNamesForBookableCustomerIds } from "../../../crud/customer/model";

interface Props {
    clinic: ClinicDetails;
    teamPreventUsers: { id: string; name: string }[];
    conflicts: string[] | false | undefined;
    onCliniciansChanged: (clinicians: { id: string; name: string }[]) => void;
}

export const StandardClinicEdit: React.FunctionComponent<Props> = (props: Props) => {
    const { clinic, teamPreventUsers, conflicts, onCliniciansChanged } = props;
    const customers = useSelector((state: ApplicationState) => state.customers);

    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!customers || customers?.length === 0) {
            dispatch(loadCustomers());
        }
    }, [customers, dispatch]);

    if (!clinic)
    {
        return null;
    }

    return (
        <Grid>
            <Detail label="Product Type" value={clinic.clinicType} />
            {
                clinic.billableByType &&
                <Detail label="Billable By" value={clinic.billableByType} />
            }
            {
                clinic.billableCustomerIds?.length > 0 &&
                <>
                    <Detail label="Billable Customer" value={getCustomerNamesForBillableCustomerIds(clinic.billableCustomerIds, customers)} />
                    {
                        clinic.billableOrgStructure &&
                        <>
                            <Detail label="Billable Org Level 1" value={clinic.billableOrgStructure.name} />
                        </>
                    }
                </>
            }
            <Detail label="Start" value={clinic.start.format("DD-MM-YYYY HH:mm")} />
            <Detail label="End" value={clinic.end.format("DD-MM-YYYY HH:mm")} />
            <Detail label="Room" value={(clinic.rooms?.map(r => r.name).join(", ")) ?? ""} />
            <Detail label="Clinicians Required" value={clinic.cliniciansRequired.toString()} />
            <ClinicianSelector
                restrictToOneClinician
                selectedClinicians={teamPreventUsers}
                highlight={{ start: clinic.start, end: clinic.end }}
                conflicts={conflicts}
                onCliniciansChanged={onCliniciansChanged}
            />
            {
                clinic.slotLengthInMinutes &&
                <Detail label="Appointment Length" value={`${clinic.slotLengthInMinutes.toString()} minutes`} />
            }
            <Detail label="Bookable Customers" value={ getCustomerNamesForBookableCustomerIds(clinic.customerIds, customers)} />
        </Grid>
    );
};
